import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {},
  props: {
    autofocus: Boolean,
    disabled: Boolean,
    value: String,
    title: String,
    type: {
      type: String,
      default: 'text'
    },
    validateInputHandler: Function,
    keypressenterhandler: Function,
    keypresshandler: Function,
    underlineText: String,
    symbol: String,
    icon: String
  },
  data () {
    return {}
  },
  async created () {},
  validations: {},
  computed: {
    ...mapState({}),
    ...mapGetters({})
  },
  methods: {
    ...mapActions({}),
    clickOnIcon () {
      this.$emit("iconClick")
    },
    onInputHandler (event) {
      this.validateInputHandler && this.validateInputHandler(event)
      this.$emit('change', event.target.value)
    },
    keyPressHandler (event) {
      this.keypresshandler && this.keypresshandler(event)
    },
    keyPressEnterHandler (event) {
      this.keypressenterhandler && this.keypressenterhandler(event)
    },
    convertCurrencySymbol (symbol) {
      return symbol === 'AUDT' ? 'AUD' : symbol
    }
  }
}
